import { ALLOW_EDIT } from '../../../utils/OperationPermissions';
import mutationQuery from 'graphql/mutations/product/ProductBulkImageMutation.graphql';

const ProductBulkImageImport = {
  type: 'mockEntities',
  title: 'Product Bulk Image Import',
  formTitle: 'Product Bulk Image Import',
  formUrl: '/Products/BulkImageImport/',
  update: mutationQuery,
  screenReference: 'PRODUCTS_BULK_IMAGE_IMPORT',
  operations: ALLOW_EDIT,
  returnUrl: 'back',
  pristineWhenIdIsNull: true, //Bulk image import never has an id - Need this prop to let the pristine check run through (Otherwise it's always highlighted as it's a "new" entity).
};

export default ProductBulkImageImport;
